import SelectorQuantity from '@catalogo/ui-americanas-mobile-product-main-area/src/components/product-offer/selector-quantity';

export default SelectorQuantity;
